import { render } from "./TimelineNr5.vue?vue&type=template&id=22d254e2&scoped=true"
import script from "./TimelineNr5.vue?vue&type=script&lang=js"
export * from "./TimelineNr5.vue?vue&type=script&lang=js"

import "./TimelineNr5.vue?vue&type=style&index=0&id=22d254e2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d254e2"]])

export default __exports__